import {ActionReducer, ActionReducerMap, createFeatureSelector} from '@ngrx/store';
import * as fromSettings from '../reducers/settings.reducer';
import {combineReducers} from '@ngrx/store';

export interface SettingsState {
  settings: fromSettings.SettingsState;
}

export const reducers: ActionReducerMap<SettingsState> = {
  settings: fromSettings.reducer,
};

export const reducer: ActionReducer<SettingsState> = combineReducers(reducers);




// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/settings/store/reducers/index.ts